import { Component, ElementRef } from '@angular/core';
import { Broadcaster } from '../service/Broadcaster';
import { SingService } from '../service/sing.service';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
    selector: 'dealer-add-access-comp',
    templateUrl: 'add-access/index.html',
     styleUrls: ['add-access/bootstrap.min.css','add-access/update.css','add-access/style.css'], //left-menu/style.min.css
})
export class DealerAddAccessComponent {
    List: any = ['03/02 - 11/02', '12/02 - 22/02', '23/02 - 30/02'];
    phone: string = '';
    constructor(
        private broadcaster: Broadcaster,
        private elRef: ElementRef,
        private httpService: SingService,
        private route: ActivatedRoute,
        private router: Router,
    ) { }

    ngOnInit() { }
    AddPhone() {
        if (this.phone !== '') {
            this.List.push(this.phone);
            this.phone = '';
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/components/dealer/dealer-add-access.component.ts